import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetWorklistRisks = (params) =>
  axios.get(apiPaths.risksBase, {
    params: {
      ...params,
      only_in_worklist: true,
      sort: '-updated_at_risk_and_relations_and_messages',
      paging: false
    }
  });

const onGetWorklistRiskMessages = (riskId) =>
  axios.get(`${apiPaths.worklistBase}/messages/`, { params: { risk_id: riskId } });

const onGetWorklistRiskUnreadSince = (riskId) =>
  axios.get(`${apiPaths.worklistBase}/unread-since`, { params: { risk_id: riskId } });

const onDeleteWorklistRiskUnreadSince = (riskId) =>
  axios.delete(`${apiPaths.worklistBase}/unread-since`, { params: { risk_id: riskId } });

const onGetRiskMessageRecipientOrganizations = (riskId) =>
  axios.get(`${apiPaths.worklistBase}/message-recipient-organizations`, { params: { risk_id: riskId } });

const onUpdateWorklistRiskMessage = (message) => axios.put(`${apiPaths.worklistBase}/messages/${message.id}`, message);

const onCreateWorklistRiskMessage = (riskId, message) =>
  axios.post(`${apiPaths.worklistBase}/messages`, message, { params: { risk_id: riskId } });

const onGetWorklistRiskRecommendations = (riskId) =>
  axios.get(`${apiPaths.worklistBase}/recommendations`, { params: { risk_id: riskId } });

const onGetWorklistRiskReminders = (riskId) =>
  axios.get(`${apiPaths.worklistBase}/reminders`, { params: { risk_id: riskId } });

const onCreateWorklistRiskReminder = (riskId, reminder) =>
  axios.post(`${apiPaths.worklistBase}/reminder`, reminder, { params: { risk_id: riskId } });

const onUpdateWorklistRiskReminder = (reminderId, reminder) =>
  axios.put(`${apiPaths.worklistBase}/reminders/${reminderId}`, reminder);

const onDeleteWorklistRiskReminder = (reminderId) => axios.delete(`${apiPaths.worklistBase}/reminders/${reminderId}`);

export {
  onGetWorklistRisks,
  onGetWorklistRiskMessages,
  onGetWorklistRiskUnreadSince,
  onDeleteWorklistRiskUnreadSince,
  onGetRiskMessageRecipientOrganizations,
  onCreateWorklistRiskMessage,
  onUpdateWorklistRiskMessage,
  onGetWorklistRiskRecommendations,
  onGetWorklistRiskReminders,
  onCreateWorklistRiskReminder,
  onUpdateWorklistRiskReminder,
  onDeleteWorklistRiskReminder
};
